// extracted by mini-css-extract-plugin
module.exports = {"container":"Certificate_container__3kQ72","exit":"Certificate_exit__1DP3V","score":"Certificate_score__1wb0H"};